module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "chapter-number---IVP sigil_not_in_toc"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevii",
      "title": "vii"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "chapter-title---IVP",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "veryfirst"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/07_prelude#_idTextAnchor004"
    }
  }, [_vm._v("A Necessary Prelude\t")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/08_part1#_idTextAnchor007"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("PART I. THE STRUGGLE")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/09_ch1#_idTextAnchor012"
    }
  }, [_vm._v("1 Hard Thoughts About God")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/10_ch2#_idTextAnchor060"
    }
  }, [_vm._v("2 Don’t Answer Why")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/11_ch3#_idTextAnchor110"
    }
  }, [_vm._v("3 Longing and Lament")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/12_ch4#_idTextAnchor228",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Embracing Our Embodiment")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/13_ch5#_idTextAnchor379",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Questions That Come with Pain")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_part2#_idTextAnchor464",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("PART II. THE STRANGENESS OF GOD")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15_ch6#_idTextAnchor471",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 One with Us: Incarnation")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/16_ch7#_idTextAnchor643",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 One for Us: Cross")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/17_ch8#_idTextAnchor826",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Risen and Remaining")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/18_part3#_idTextAnchor1072",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("PART III. LIFE TOGETHER")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/19_ch9#_idTextAnchor1077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Faith, Hope, and Love")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/20_ch10#_idTextAnchor1232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Confession and the Other")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/21_ch11#_idTextAnchor1383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Faithful")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/22_acknowledgments#_idParaDest-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1507",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/24_general_index#_idTextAnchor1952",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Index")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/25_scripture_index#_idTextAnchor1954",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index\t")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/26_praise#_idTextAnchor1956",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("Embodied Hope")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/27_author#_idTextAnchor1957",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/28_moreIVP#_idTextAnchor1958",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_study_guide#_idTextAnchor1960",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("EMBODIED HOPE STUDY GUIDE")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_study_guide#_idParaDest-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part I. The Struggle")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_study_guide#_idTextAnchor1963",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 1: Hard Thoughts About God")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_study_guide#_idTextAnchor1964",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 2: Don’t Answer Why")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_study_guide#_idTextAnchor1965",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 3: Longing and Lament\t")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_study_guide#_idTextAnchor1968",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 4: Embracing Our Embodiment")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_study_guide#_idTextAnchor1970",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 5: Questions That Come with Pain")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_study_guide#_idTextAnchor1972",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II. The Strangeness of God")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_study_guide#_idTextAnchor1973",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 6: One with Us")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_study_guide#_idTextAnchor1974",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 7: One for Us")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_study_guide#_idTextAnchor1976",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 8: Risen and Remaining")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_study_guide#_idTextAnchor1978",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III. Life Together")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_study_guide#_idTextAnchor1979",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 9: Faith, Hope, and Love")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_study_guide#_idTextAnchor1981",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 10: Confession and the Other")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_study_guide#_idTextAnchor1983",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 11: Faithful")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_study_guide#_idTextAnchor1985",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Outlines")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_study_guide#_idTextAnchor1986",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/03_copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")]), _c('br'), _c('br')])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageviii",
      "title": "viii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7afff1e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/06_contents.vue
// module id = 66
// module chunks = 0